<template>
  <div class="form-steps">
    <app-form-step-1 v-if="currentStep === 1" />
    <app-form-step-2 v-else-if="currentStep === 2" />
    <app-form-step-3 v-else-if="currentStep === 3" />
    <app-form-step-4 v-else-if="currentStep === 4" />
    <app-form-step-5 v-else-if="currentStep === 5" />
    <app-form-step-6 v-else-if="currentStep === 6" />
  </div>
</template>

<script>
import { mapState } from 'vuex'

import AppFormStep1 from '@/components/FormStep1.vue'
import AppFormStep2 from '@/components/FormStep2.vue'
import AppFormStep3 from '@/components/FormStep3.vue'
import AppFormStep4 from '@/components/FormStep4.vue'
import AppFormStep5 from '@/components/FormStep5.vue'
import AppFormStep6 from '@/components/FormStep6.vue'

export default {
  name: 'appFormSteps',
  computed: {
    ...mapState('form', ['currentStep']),
  },
  components: {
    AppFormStep1,
    AppFormStep2,
    AppFormStep3,
    AppFormStep4,
    AppFormStep5,
    AppFormStep6,
  },
}
</script>

<style lang="scss" scoped>
.form-steps {
  text-align: center;
}
</style>

<style lang="scss">
.form-steps {
  .el-form-item {
    margin-bottom: 16px !important;

    @include desktop {
      margin-bottom: 24px !important;
    }
  }
}
</style>
